export const accordionStyles = {
  margin: "0px !important",
  boxShadow: "none !important",
  border: "1px solid rgba(234, 234, 234, 1)",
  borderBottom: "none",
  "&:first-child": {
    borderTopLeftRadius: "8px",
    borderTopRightRadius: "8px",
  },
  "&:last-child": {
    borderBottom: "1px solid rgba(234, 234, 234, 1)",
    borderBottomLeftRadius: "8px",
    borderBottomRightRadius: "8px",
    marginBottom: "16px",
  },
  "&::before": {
    display: "none",
  },
};

export const accordionSummaryStyles = {
  minHeight: "68px !important",
  borderBottom: "1px solid transparent",
  "&.Mui-expanded": {
    boxShadow: "0px 4px 8px -2px rgba(0, 0, 0, 0.16)",
    borderBottom: "1px solid rgba(234, 234, 234, 1)",
  },
  "& .MuiAccordionSummary-content": {
    alignItems: "center",
    margin: "0px !important",
  },
};

export const summaryBoxStyles = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
};

export const iconStyles = {
  transform: "rotate(0deg)",
  transition: "transform 0.3s",
  mr: "4px",
  color: "rgba(62, 63, 76, 1)",
  fontSize: "20px",
  ".Mui-expanded &": {
    transform: "rotate(90deg)", // or -90deg for Hebrew
  },
};

export const avatarStyles = {
  width: 32,
  height: 32,
};

export const accordionDetailsStyles = {
  padding: "8px 16px !important",
  backgroundColor: "rgba(249, 249, 252, 1)",
};

export const labelStyles = {
  minWidth: "100px",
  fontWeight: 400,
  fontSize: "14px",
  color: "rgba(62, 63, 76, 0.75)",
};

export const valueStyles = {
  fontWeight: 400,
  fontSize: "14px",
  color: "rgba(62, 63, 76, 1)",
};

export const detailRowStyles = {
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  gap: "20px",
  minHeight: "54px",
};

export const actionContainerStyles = {
  display: "flex",
  alignItems: "center",
  flexWrap: "wrap",
  justifyContent: "flex-start",
  gap: "20px",
  minHeight: "54px",
};
